<template>
  <div class="spreadEntity-div">
    <div>
      <el-button class="base-button" size="mini" type="primary" @click="addAction"
        >添加形状</el-button
      >
      <el-table height="200" stripe :data="ruleForm.tableData" class="outputTable">
        <el-table-column label="序号" type="index" width="50"> </el-table-column>
        <el-table-column prop="delay" label="延迟(秒)">
          <template slot-scope="scope">
            <el-input-number
              controls-position="right"
              :min="0"
              :step="0.1"
              size="mini"
              v-model="scope.row.delay"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="步长(米)">
          <template slot-scope="scope">
            <el-input-number
              controls-position="right"
              :min="0"
              :step="0.1"
              size="mini"
              v-model="scope.row.time"
            ></el-input-number>
          </template>
        </el-table-column>
        <el-table-column prop="order" label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteAction(scope.row)" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-form
      size="mini"
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="100px"
      class="demo-ruleForm"
    >
      <el-form-item label="是否启用">
        <el-switch
          v-model="ruleForm.isUse"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <el-form-item label="是否放大">
        <el-switch
          v-model="ruleForm.isBig"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
      </el-form-item>
      <div class="form-bottom">
        <el-button
          class="base-button"
          size="mini"
          type="primary"
          @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button class="base-button" size="mini" @click="resetForm('ruleForm')"
          >取消</el-button
        >
      </div>
    </el-form>
  </div>
</template>
<script>
let plotArr = [];
export default {
  props: ["subData"],
  data() {
    return {
      typeOptions: [],
      ruleForm: {
        isBig: true,
        isUse: false,
        tableData: [],
      },
      rules: {},
    };
  },
  created() {
    if (
      this.subData &&
      this.subData.params &&
      this.subData.params.type == "spreadEntity" &&
      this.subData.params.data.tableData &&
      this.subData.params.data.tableData.length > 0
    ) {
      this.ruleForm = JSON.parse(JSON.stringify(this.subData.params.data));
      this.addLine();
    } else {
      //   let data = this.subData.data;
      //   let uuid = data.markId;
      //   var entity = viewer.entities.getById(uuid);
      //   if (!entity) {
      //     return;
      //   }
      //   let obj = {
      //     delay: 1,
      //     time: 1,
      //   };
      //   var positions = entity.polygon.hierarchy.getValue().positions.slice();
      //   obj.positions = positions;
      //   this.ruleForm.tableData.push(obj);
    }
  },
  methods: {
    addLine() {
      var list = this.ruleForm.tableData || [];
      for (var i = 0; i < list.length; i++) {
        var positions = list[i].positions;
        let l = this.createLineEntity(positions);
        plotArr.push(l);
      }
    },
    createLineEntity(positions) {
      var line = viewer.entities.add({
        show: true,
        polyline: {
          positions: positions,
          show: true,
          material: Cesium.Color.RED,
          width: 3,
          clampToGround: true,
          disableDepthTestDistance: Number.MAX_VALUE,
        },
      });
      return line;
    },
    addAction() {
      let obj = {
        delay: 1,
        time: 1,
      };
      let data = this.subData.data;
      let uuid = data.markId;
      var entity = viewer.entities.getById(uuid);
      if (!entity) {
        return;
      }

      var positions = entity.polygon.hierarchy.getValue().positions.slice();
      obj.positions = positions;
      console.log(this.subData);
      this.ruleForm.tableData.push(obj);
    },
    deleteAction(obj) {
      let arr = this.ruleForm.tableData;
      const index = arr.indexOf(obj);
      if (index > -1) {
        arr.splice(index, 1);
      }
    },
    submitForm() {
      this.subData.params.type = "spreadEntity";
      this.subData.params.data = this.ruleForm;
      this.$parent.close();
    },
    resetForm() {
      this.$parent.close();
    },
  },

  beforeDestroy() {
    for (let i = 0; i < plotArr.length; i++) {
      viewer.entities.remove(plotArr[i]);
    }
  },
};
</script>
<style>
.form-bottom {
  margin-bottom: 0 !important;
  text-align: center;
}

.el-input-number {
  width: 100%;
}
</style>
